import { risapi, getAxiosConfig, getAPIFullUrl } from './risapi';

/**
 * Fetches the report configuration for a specific module (e.g., 'club_finance').
 * @param {string} module - The name of the report module.
 * @param {function} callback - The function to call with the response.
 */
export const getReportParameters = async (module, callback) => {
    try {
        const response = await risapi.get(`/api/reports/${module}/parameters`, getAxiosConfig());
        callback(response.data);
    } catch (error) {
        callback(error);
    }
};

/**
 * Requests a report from the backend.
 * @param {string} module - The name of the report module.
 * @param {object} payload - The report options and filters.
 * @param {function} callback - The function to call with the response (Blob for PDF, JSON for Excel).
 */
export const generateReport = async (module, payload, callback) => {
    try {
        const config = {
            ...getAxiosConfig(),
            responseType: payload.reportFormat === 'pdf' ? 'blob' : 'json' // Handle PDF blob
        };
        const response = await risapi.post(`/api/reports/${module}/generate`, payload, config);
        
        callback(response.data); // Pass the raw blob or JSON data
        
    } catch (error) {
        // Handle API errors (like 404, 500)
        callback({ error: true, data: error.response.data });
    }
};